/**
 * `localStorage`, который не роняет приложение.
 *
 * В WebView Telegram хранилище бывает недоступно (приватный режим, запрет
 * сторонних данных в iframe web-клиента) и бросает на любое обращение.
 * Черновик или выбор темы в таком случае просто не переживут перезапуск —
 * это лучше, чем белый экран.
 */
export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // Хранилище недоступно или переполнено — состояние живёт до закрытия приложения.
    }
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key)
    } catch {
      // см. setItem
    }
  },
  /** Все ключи хранилища — чтобы стереть записи по префиксу. Недоступно — пусто. */
  keys(): string[] {
    try {
      return Object.keys(window.localStorage)
    } catch {
      return []
    }
  },
}
